<template>
  <div class="home">
    <div v-if="isLoggedin">
      <hero-home></hero-home>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HeroHome from "@/components/template/HeroHome.vue";

export default {
  name: "home",
  components: {
    HeroHome
  },
  props: ['isLoggedin'],
  created() {
    this.$ga.page({
      page: "/",
      title: "Home Page",
      location: window.location.href
    });
  }
};
</script>
